<div class="toast-container">
  @for (notification of notifications(); track trackById($index, notification)) {
    <div class="toast-item" [class]="'toast-' + notification.type" role="alert">
      <div class="toast-icon">
        <i class="bi" [class]="getIcon(notification.type)"></i>
      </div>
      <div class="toast-content">
        @if (notification.title) {
          <div class="toast-title">{{ notification.title }}</div>
        }
        <div class="toast-message">{{ notification.message }}</div>
      </div>
      <button class="toast-close" (click)="dismiss(notification.id)" aria-label="Close">
        <i class="bi bi-x"></i>
      </button>
    </div>
  }
</div>
